(function () {
  'use strict';

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  /* Hero ready state for image scale animation */
  qsa('.hero-campaign').forEach(function (hero) {
    requestAnimationFrame(function () {
      hero.classList.add('is-ready');
    });
  });

  /* Mobile nav toggle */
  qsa('[data-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = qs(btn.getAttribute('aria-controls') ? '#' + btn.getAttribute('aria-controls') : '[data-mobile-nav]');
      if (!target) return;
      var open = !target.classList.contains('is-open');
      target.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* Search panel toggle */
  qsa('[data-search-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = qs('[data-search-panel]');
      if (!panel) return;
      var open = !panel.classList.contains('is-open');
      panel.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var input = qs('input[type="search"]', panel);
        if (input) input.focus();
      }
    });
  });

  /* Product carousel controls */
  qsa('[data-carousel]').forEach(function (carousel) {
    var track = qs('[data-carousel-track]', carousel);
    var prev = qs('[data-carousel-prev]', carousel);
    var next = qs('[data-carousel-next]', carousel);
    if (!track) return;

    function scrollByCard(dir) {
      var card = qs('.product-carousel__item', track);
      var amount = card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { scrollByCard(-1); });
    if (next) next.addEventListener('click', function () { scrollByCard(1); });
  });

  /* Cart drawer */
  var drawer = qs('[data-cart-drawer]');

  function openCartDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  qsa('[data-cart-open]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      if (!drawer) return;
      e.preventDefault();
      openCartDrawer();
    });
  });

  qsa('[data-cart-close]', drawer || document).forEach(function (el) {
    el.addEventListener('click', closeCartDrawer);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCartDrawer();
  });

  /* Product gallery thumbs */
  qsa('[data-product-gallery]').forEach(function (gallery) {
    var main = qs('[data-gallery-main]', gallery);
    var thumbs = qsa('[data-gallery-thumb]', gallery);
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-src');
        var srcset = thumb.getAttribute('data-srcset');
        if (main && src) {
          main.src = src;
          if (srcset) main.srcset = srcset;
        }
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  /* Variant selection + add to cart (Ajax) */
  qsa('[data-product-form]').forEach(function (form) {
    var variantInput = qs('[name="id"]', form);
    var variantsScript = qs('[data-product-variants]', form.closest('[data-product]'));
    var priceEl = qs('[data-product-price]', form.closest('[data-product]'));
    var submitBtn = qs('[type="submit"]', form);
    var variants = [];

    try {
      variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    } catch (err) {
      variants = [];
    }

    function selectedOptions() {
      return qsa('[data-option-index]', form).map(function (fieldset) {
        var checked = qs('input:checked', fieldset);
        return checked ? checked.value : null;
      });
    }

    function findVariant(options) {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return opt === options[i];
        });
      });
    }

    function formatMoney(cents) {
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, window.themeMoneyFormat || '{{amount}}');
      }
      return '$' + (cents / 100).toFixed(2);
    }

    function updateVariant() {
      var options = selectedOptions();
      if (options.some(function (o) { return o == null; })) return;
      var variant = findVariant(options);
      if (!variant || !variantInput) return;

      variantInput.value = variant.id;

      if (priceEl) {
        if (variant.compare_at_price > variant.price) {
          priceEl.innerHTML =
            '<span class="price--sale">' + formatMoney(variant.price) + '</span>' +
            '<s>' + formatMoney(variant.compare_at_price) + '</s>';
        } else {
          priceEl.innerHTML = formatMoney(variant.price);
        }
      }

      if (submitBtn) {
        if (!variant.available) {
          submitBtn.disabled = true;
          submitBtn.textContent = submitBtn.getAttribute('data-sold-out') || 'Sold out';
        } else {
          submitBtn.disabled = false;
          submitBtn.textContent = submitBtn.getAttribute('data-add') || 'Add to bag';
        }
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    qsa('input[type="radio"]', form).forEach(function (input) {
      input.addEventListener('change', updateVariant);
    });

    form.addEventListener('submit', function (e) {
      if (!drawer) return;
      e.preventDefault();
      var fd = new FormData(form);
      fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: fd
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          return fetch('/cart.js');
        })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          qsa('[data-cart-count]').forEach(function (el) {
            el.textContent = String(cart.item_count);
            el.hidden = cart.item_count === 0;
          });
          window.location.href = '/cart';
        })
        .catch(function () {
          form.submit();
        });
    });

    updateVariant();
  });

  /* Quantity steppers */
  qsa('[data-qty]').forEach(function (wrap) {
    var input = qs('input', wrap);
    var minus = qs('[data-qty-minus]', wrap);
    var plus = qs('[data-qty-plus]', wrap);
    if (!input) return;

    if (minus) {
      minus.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, val - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    if (plus) {
      plus.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 1;
        input.value = val + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  });
})();
